import { useMutation } from '@tanstack/react-query';
import { Usuarios } from '../types/UsuariosTipo';
import putUser from '../queries/putUser';

export default function usePutUser(onSuccessEditUser: () => void) {
  return useMutation(
    ({
      usuarioAtual,
      userId,
      data,
    }: {
      usuarioAtual: Usuarios;
      userId: number;
      data: Usuarios;
    }) => {
      //@ts-ignore
      Object.keys(data as any).forEach((key: string) => data[key] === undefined && delete data[key]);

      Object.assign(usuarioAtual, data);

      return putUser(userId, usuarioAtual, () => onSuccessEditUser());
      })
    }
